/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ApClassTypeBase,
  ApClassTypeBaseOptional,
  ApClassTypeBaseMetaI,
  ApClassTypeBaseTrackedI,
} from "./ap-class-type-base";
import {
  ApClassTypeBaseTracked,
  ApClassTypeBaseMeta,
} from "./ap-class-type-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ApClassTypeRef,
  ApClassTypeRefOptional,
  ApClassTypeRefMetaI,
  ApClassTypeRefTrackedI,
} from "./ap-class-type-ref";
import { ApClassTypeRefTracked, ApClassTypeRefMeta } from "./ap-class-type-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DBHistory,
  DBHistoryOptional,
  DBHistoryMetaI,
  DBHistoryTrackedI,
} from "./dbhistory";
import { DBHistoryTracked, DBHistoryMeta } from "./dbhistory";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  RatingRef,
  RatingRefOptional,
  RatingRefMetaI,
  RatingRefTrackedI,
} from "./rating-ref";
import { RatingRefTracked, RatingRefMeta } from "./rating-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassTypeFull,
  UnifiedClassTypeFullOptional,
  UnifiedClassTypeFullMetaI,
  UnifiedClassTypeFullTrackedI,
} from "./unified-class-type-full";
import {
  UnifiedClassTypeFullTracked,
  UnifiedClassTypeFullMeta,
} from "./unified-class-type-full";

/**
 *
 * @export
 * @interface ApClassTypeFull
 */
export interface ApClassTypeFullOptional extends ApClassTypeBaseOptional {
  /**
   *
   * @type {number}
   * @memberof ApClassTypeFull
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  typeName?: string;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeFull
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  prereqMustComplete?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeFull
   */
  signupMax?: number;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeFull
   */
  signupMin?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  noSignup?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  descLong?: string;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  descShort?: string;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  colorCode?: string;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeFull
   */
  priceDefault?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  disallowIfOverkill?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  teachUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  allowTeacher?: boolean;
  /**
   *
   * @type {RatingRef}
   * @memberof ApClassTypeFull
   */
  teachRating?: RatingRefOptional;
  /**
   *
   * @type {RatingRef}
   * @memberof ApClassTypeFull
   */
  ratingPrereq?: RatingRefOptional;
  /**
   *
   * @type {RatingRef}
   * @memberof ApClassTypeFull
   */
  ratingOverkill?: RatingRefOptional;
  /**
   *
   * @type {ApClassTypeRef}
   * @memberof ApClassTypeFull
   */
  classPrereq?: ApClassTypeRefOptional;
  /**
   *
   * @type {ApClassTypeRef}
   * @memberof ApClassTypeFull
   */
  classOverkill?: ApClassTypeRefOptional;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  createdBy?: string;
}

export interface ApClassTypeFull
  extends
    ApClassTypeFullOptional,
    ApClassTypeBase,
    ApClassTypeRef,
    DBHistory,
    Deletable,
    UnifiedClassTypeFull {
  /**
   *
   * @type {number}
   * @memberof ApClassTypeFull
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  typeName?: string;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeFull
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  prereqMustComplete?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeFull
   */
  signupMax?: number;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeFull
   */
  signupMin?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  noSignup?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  descLong?: string;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  descShort?: string;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  colorCode?: string;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeFull
   */
  priceDefault?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  disallowIfOverkill?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  teachUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  allowTeacher?: boolean;
  /**
   *
   * @type {RatingRef}
   * @memberof ApClassTypeFull
   */
  teachRating?: RatingRef;
  /**
   *
   * @type {RatingRef}
   * @memberof ApClassTypeFull
   */
  ratingPrereq?: RatingRef;
  /**
   *
   * @type {RatingRef}
   * @memberof ApClassTypeFull
   */
  ratingOverkill?: RatingRef;
  /**
   *
   * @type {ApClassTypeRef}
   * @memberof ApClassTypeFull
   */
  classPrereq?: ApClassTypeRef;
  /**
   *
   * @type {ApClassTypeRef}
   * @memberof ApClassTypeFull
   */
  classOverkill?: ApClassTypeRef;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  createdBy?: string;
}

export interface ApClassTypeFullTrackedI extends ApClassTypeBaseOptional {
  /**
   *
   * @type {number}
   * @memberof ApClassTypeFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  typeName?: string;
  typeNameIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeFull
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  prereqMustComplete?: boolean;
  prereqMustCompleteIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeFull
   */
  signupMax?: number;
  signupMaxIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeFull
   */
  signupMin?: number;
  signupMinIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  noSignup?: boolean;
  noSignupIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  descLong?: string;
  descLongIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  descShort?: string;
  descShortIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  colorCode?: string;
  colorCodeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeFull
   */
  priceDefault?: number;
  priceDefaultIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  disallowIfOverkill?: boolean;
  disallowIfOverkillIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  teachUrl?: string;
  teachUrlIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  allowTeacher?: boolean;
  allowTeacherIsSet: boolean;
  /**
   *
   * @type {RatingRef}
   * @memberof ApClassTypeFull
   */
  teachRating?: RatingRefTrackedI;
  teachRatingIsSet: boolean;
  /**
   *
   * @type {RatingRef}
   * @memberof ApClassTypeFull
   */
  ratingPrereq?: RatingRefTrackedI;
  ratingPrereqIsSet: boolean;
  /**
   *
   * @type {RatingRef}
   * @memberof ApClassTypeFull
   */
  ratingOverkill?: RatingRefTrackedI;
  ratingOverkillIsSet: boolean;
  /**
   *
   * @type {ApClassTypeRef}
   * @memberof ApClassTypeFull
   */
  classPrereq?: ApClassTypeRefTrackedI;
  classPrereqIsSet: boolean;
  /**
   *
   * @type {ApClassTypeRef}
   * @memberof ApClassTypeFull
   */
  classOverkill?: ApClassTypeRefTrackedI;
  classOverkillIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeFull
   */
  createdBy?: string;
  createdByIsSet: boolean;
}

transformDatesMap.set("ApClassTypeFull", function (model: ApClassTypeFull) {
  const transformDatesteachRating = transformDatesMap.get("RatingRef");
  if (transformDatesteachRating && model.teachRating) {
    transformDatesteachRating(model.teachRating);
  }
  const transformDatesratingPrereq = transformDatesMap.get("RatingRef");
  if (transformDatesratingPrereq && model.ratingPrereq) {
    transformDatesratingPrereq(model.ratingPrereq);
  }
  const transformDatesratingOverkill = transformDatesMap.get("RatingRef");
  if (transformDatesratingOverkill && model.ratingOverkill) {
    transformDatesratingOverkill(model.ratingOverkill);
  }
  const transformDatesclassPrereq = transformDatesMap.get("ApClassTypeRef");
  if (transformDatesclassPrereq && model.classPrereq) {
    transformDatesclassPrereq(model.classPrereq);
  }
  const transformDatesclassOverkill = transformDatesMap.get("ApClassTypeRef");
  if (transformDatesclassOverkill && model.classOverkill) {
    transformDatesclassOverkill(model.classOverkill);
  }
  if (typeof model.updatedOn == "string")
    model.updatedOn = new Date(model.updatedOn);
  if (typeof model.createdOn == "string")
    model.createdOn = new Date(model.createdOn);
});

export type ApClassTypeFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  typeName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  prereqMustComplete: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  signupMax: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  signupMin: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  noSignup: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  descLong: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  descShort: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  colorCode: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  priceDefault: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  disallowIfOverkill: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  teachUrl: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  allowTeacher: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  teachRating: PropertyMeta<RatingRefMetaI>;
  //isDate: false
  //isDatetime: false
  ratingPrereq: PropertyMeta<RatingRefMetaI>;
  //isDate: false
  //isDatetime: false
  ratingOverkill: PropertyMeta<RatingRefMetaI>;
  //isDate: false
  //isDatetime: false
  classPrereq: PropertyMeta<ApClassTypeRefMetaI>;
  //isDate: false
  //isDatetime: false
  classOverkill: PropertyMeta<ApClassTypeRefMetaI>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
}>;

export var ApClassTypeFullMeta: ApClassTypeFullMetaI =
  {} as ApClassTypeFullMetaI;
ApClassTypeFullMeta = typeMeta("ApClassTypeFull", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  typeName: propertyMeta("typeName", false, false, false, MetaTypesBase.string),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  prereqMustComplete: propertyMeta(
    "prereqMustComplete",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  signupMax: propertyMeta(
    "signupMax",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  signupMin: propertyMeta(
    "signupMin",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  noSignup: propertyMeta(
    "noSignup",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  descLong: propertyMeta("descLong", false, false, false, MetaTypesBase.string),
  descShort: propertyMeta(
    "descShort",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  colorCode: propertyMeta(
    "colorCode",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  priceDefault: propertyMeta(
    "priceDefault",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  disallowIfOverkill: propertyMeta(
    "disallowIfOverkill",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  teachUrl: propertyMeta("teachUrl", false, false, false, MetaTypesBase.string),
  allowTeacher: propertyMeta(
    "allowTeacher",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  teachRating: propertyMeta("teachRating", false, false, false, RatingRefMeta),
  ratingPrereq: propertyMeta(
    "ratingPrereq",
    false,
    false,
    false,
    RatingRefMeta,
  ),
  ratingOverkill: propertyMeta(
    "ratingOverkill",
    false,
    false,
    false,
    RatingRefMeta,
  ),
  classPrereq: propertyMeta(
    "classPrereq",
    false,
    false,
    false,
    ApClassTypeRefMeta,
  ),
  classOverkill: propertyMeta(
    "classOverkill",
    false,
    false,
    false,
    ApClassTypeRefMeta,
  ),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = ApClassTypeFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ApClassTypeRefMeta]);
  metaI.assignId.inheritedFrom = ApClassTypeRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([ApClassTypeBaseMeta]);
  metaI.typeName.inheritedFrom = ApClassTypeBaseMeta.typeName;
  metaI.displayOrder.inheritedFrom = ApClassTypeBaseMeta.displayOrder;
  metaI.prereqMustComplete.inheritedFrom =
    ApClassTypeBaseMeta.prereqMustComplete;
  metaI.signupMax.inheritedFrom = ApClassTypeBaseMeta.signupMax;
  metaI.signupMin.inheritedFrom = ApClassTypeBaseMeta.signupMin;
  metaI.noSignup.inheritedFrom = ApClassTypeBaseMeta.noSignup;
  metaI.descLong.inheritedFrom = ApClassTypeBaseMeta.descLong;
  metaI.descShort.inheritedFrom = ApClassTypeBaseMeta.descShort;
  metaI.colorCode.inheritedFrom = ApClassTypeBaseMeta.colorCode;
  metaI.priceDefault.inheritedFrom = ApClassTypeBaseMeta.priceDefault;
  metaI.disallowIfOverkill.inheritedFrom =
    ApClassTypeBaseMeta.disallowIfOverkill;
  metaI.teachUrl.inheritedFrom = ApClassTypeBaseMeta.teachUrl;
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassTypeFullMeta]);
  metaI.assignId.inheritedFrom = UnifiedClassTypeFullMeta.assignId;
  metaI.typeName.inheritedFrom = UnifiedClassTypeFullMeta.typeName;
  metaI.displayOrder.inheritedFrom = UnifiedClassTypeFullMeta.displayOrder;
  metaI.prereqMustComplete.inheritedFrom =
    UnifiedClassTypeFullMeta.prereqMustComplete;
  metaI.allowTeacher.inheritedFrom = UnifiedClassTypeFullMeta.allowTeacher;
  metaI.teachRating.inheritedFrom = UnifiedClassTypeFullMeta.teachRating;
  metaI.ratingPrereq.inheritedFrom = UnifiedClassTypeFullMeta.ratingPrereq;
  metaI.ratingOverkill.inheritedFrom = UnifiedClassTypeFullMeta.ratingOverkill;
  metaI.classPrereq.inheritedFrom = UnifiedClassTypeFullMeta.classPrereq;
  metaI.classOverkill.inheritedFrom = UnifiedClassTypeFullMeta.classOverkill;
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([DBHistoryMeta]);
  metaI.updatedOn.inheritedFrom = DBHistoryMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = DBHistoryMeta.updatedBy;
  metaI.createdOn.inheritedFrom = DBHistoryMeta.createdOn;
  metaI.createdBy.inheritedFrom = DBHistoryMeta.createdBy;
});

export class ApClassTypeFullTracked
  extends ApClassTypeBaseTracked
  implements ApClassTypeFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  typeName__I?: string = undefined;
  typeNameIsSet: boolean = false;
  set typeName(v: undefined | string) {
    if (v !== undefined) {
      this.typeName__I = v;
      this.typeNameIsSet = true;
    } else {
      this.typeName__I = v || undefined;
      this.typeNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeName() {
    return this.typeName__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  prereqMustComplete__I?: boolean = undefined;
  prereqMustCompleteIsSet: boolean = false;
  set prereqMustComplete(v: undefined | boolean) {
    if (v !== undefined) {
      this.prereqMustComplete__I = v;
      this.prereqMustCompleteIsSet = true;
    } else {
      this.prereqMustComplete__I = v || undefined;
      this.prereqMustCompleteIsSet = false;
    }
    this.changeTracker = true;
  }
  get prereqMustComplete() {
    return this.prereqMustComplete__I;
  }
  signupMax__I?: number = undefined;
  signupMaxIsSet: boolean = false;
  set signupMax(v: undefined | number) {
    if (v !== undefined) {
      this.signupMax__I = v;
      this.signupMaxIsSet = true;
    } else {
      this.signupMax__I = v || undefined;
      this.signupMaxIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupMax() {
    return this.signupMax__I;
  }
  signupMin__I?: number = undefined;
  signupMinIsSet: boolean = false;
  set signupMin(v: undefined | number) {
    if (v !== undefined) {
      this.signupMin__I = v;
      this.signupMinIsSet = true;
    } else {
      this.signupMin__I = v || undefined;
      this.signupMinIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupMin() {
    return this.signupMin__I;
  }
  noSignup__I?: boolean = undefined;
  noSignupIsSet: boolean = false;
  set noSignup(v: undefined | boolean) {
    if (v !== undefined) {
      this.noSignup__I = v;
      this.noSignupIsSet = true;
    } else {
      this.noSignup__I = v || undefined;
      this.noSignupIsSet = false;
    }
    this.changeTracker = true;
  }
  get noSignup() {
    return this.noSignup__I;
  }
  descLong__I?: string = undefined;
  descLongIsSet: boolean = false;
  set descLong(v: undefined | string) {
    if (v !== undefined) {
      this.descLong__I = v;
      this.descLongIsSet = true;
    } else {
      this.descLong__I = v || undefined;
      this.descLongIsSet = false;
    }
    this.changeTracker = true;
  }
  get descLong() {
    return this.descLong__I;
  }
  descShort__I?: string = undefined;
  descShortIsSet: boolean = false;
  set descShort(v: undefined | string) {
    if (v !== undefined) {
      this.descShort__I = v;
      this.descShortIsSet = true;
    } else {
      this.descShort__I = v || undefined;
      this.descShortIsSet = false;
    }
    this.changeTracker = true;
  }
  get descShort() {
    return this.descShort__I;
  }
  colorCode__I?: string = undefined;
  colorCodeIsSet: boolean = false;
  set colorCode(v: undefined | string) {
    if (v !== undefined) {
      this.colorCode__I = v;
      this.colorCodeIsSet = true;
    } else {
      this.colorCode__I = v || undefined;
      this.colorCodeIsSet = false;
    }
    this.changeTracker = true;
  }
  get colorCode() {
    return this.colorCode__I;
  }
  priceDefault__I?: number = undefined;
  priceDefaultIsSet: boolean = false;
  set priceDefault(v: undefined | number) {
    if (v !== undefined) {
      this.priceDefault__I = v;
      this.priceDefaultIsSet = true;
    } else {
      this.priceDefault__I = v || undefined;
      this.priceDefaultIsSet = false;
    }
    this.changeTracker = true;
  }
  get priceDefault() {
    return this.priceDefault__I;
  }
  disallowIfOverkill__I?: boolean = undefined;
  disallowIfOverkillIsSet: boolean = false;
  set disallowIfOverkill(v: undefined | boolean) {
    if (v !== undefined) {
      this.disallowIfOverkill__I = v;
      this.disallowIfOverkillIsSet = true;
    } else {
      this.disallowIfOverkill__I = v || undefined;
      this.disallowIfOverkillIsSet = false;
    }
    this.changeTracker = true;
  }
  get disallowIfOverkill() {
    return this.disallowIfOverkill__I;
  }
  teachUrl__I?: string = undefined;
  teachUrlIsSet: boolean = false;
  set teachUrl(v: undefined | string) {
    if (v !== undefined) {
      this.teachUrl__I = v;
      this.teachUrlIsSet = true;
    } else {
      this.teachUrl__I = v || undefined;
      this.teachUrlIsSet = false;
    }
    this.changeTracker = true;
  }
  get teachUrl() {
    return this.teachUrl__I;
  }
  allowTeacher__I?: boolean = undefined;
  allowTeacherIsSet: boolean = false;
  set allowTeacher(v: undefined | boolean) {
    if (v !== undefined) {
      this.allowTeacher__I = v;
      this.allowTeacherIsSet = true;
    } else {
      this.allowTeacher__I = v || undefined;
      this.allowTeacherIsSet = false;
    }
    this.changeTracker = true;
  }
  get allowTeacher() {
    return this.allowTeacher__I;
  }
  teachRating__I?: RatingRefTracked = undefined;
  teachRatingIsSet: boolean = false;
  set teachRating(v: undefined | RatingRefTracked) {
    if (v !== undefined) {
      this.teachRating__I = v;
      this.teachRatingIsSet = true;
    } else {
      this.teachRating__I = v || undefined;
      this.teachRatingIsSet = false;
    }
    this.changeTracker = true;
  }
  get teachRating() {
    return this.teachRating__I;
  }
  ratingPrereq__I?: RatingRefTracked = undefined;
  ratingPrereqIsSet: boolean = false;
  set ratingPrereq(v: undefined | RatingRefTracked) {
    if (v !== undefined) {
      this.ratingPrereq__I = v;
      this.ratingPrereqIsSet = true;
    } else {
      this.ratingPrereq__I = v || undefined;
      this.ratingPrereqIsSet = false;
    }
    this.changeTracker = true;
  }
  get ratingPrereq() {
    return this.ratingPrereq__I;
  }
  ratingOverkill__I?: RatingRefTracked = undefined;
  ratingOverkillIsSet: boolean = false;
  set ratingOverkill(v: undefined | RatingRefTracked) {
    if (v !== undefined) {
      this.ratingOverkill__I = v;
      this.ratingOverkillIsSet = true;
    } else {
      this.ratingOverkill__I = v || undefined;
      this.ratingOverkillIsSet = false;
    }
    this.changeTracker = true;
  }
  get ratingOverkill() {
    return this.ratingOverkill__I;
  }
  classPrereq__I?: ApClassTypeRefTracked = undefined;
  classPrereqIsSet: boolean = false;
  set classPrereq(v: undefined | ApClassTypeRefTracked) {
    if (v !== undefined) {
      this.classPrereq__I = v;
      this.classPrereqIsSet = true;
    } else {
      this.classPrereq__I = v || undefined;
      this.classPrereqIsSet = false;
    }
    this.changeTracker = true;
  }
  get classPrereq() {
    return this.classPrereq__I;
  }
  classOverkill__I?: ApClassTypeRefTracked = undefined;
  classOverkillIsSet: boolean = false;
  set classOverkill(v: undefined | ApClassTypeRefTracked) {
    if (v !== undefined) {
      this.classOverkill__I = v;
      this.classOverkillIsSet = true;
    } else {
      this.classOverkill__I = v || undefined;
      this.classOverkillIsSet = false;
    }
    this.changeTracker = true;
  }
  get classOverkill() {
    return this.classOverkill__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  constructor(config?: ApClassTypeFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.teachRating?.setIds();

    this.ratingPrereq?.setIds();

    this.ratingOverkill?.setIds();

    this.classPrereq?.setIds();

    this.classOverkill?.setIds();
  }
  assignFrom(
    config: ApClassTypeFullOptional,
    options?: AssignOptions,
  ): ApClassTypeFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.typeName && this.typeNameApplyFilter(optionsRequired.filter)) {
      this.typeName = config.typeName;
      if (optionsRequired.unassign) this.typeNameIsSet = false;
      else this.typeNameIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (
      config.prereqMustComplete &&
      this.prereqMustCompleteApplyFilter(optionsRequired.filter)
    ) {
      this.prereqMustComplete = config.prereqMustComplete;
      if (optionsRequired.unassign) this.prereqMustCompleteIsSet = false;
      else this.prereqMustCompleteIsSet = true;
    }
    if (config.signupMax && this.signupMaxApplyFilter(optionsRequired.filter)) {
      this.signupMax = config.signupMax;
      if (optionsRequired.unassign) this.signupMaxIsSet = false;
      else this.signupMaxIsSet = true;
    }
    if (config.signupMin && this.signupMinApplyFilter(optionsRequired.filter)) {
      this.signupMin = config.signupMin;
      if (optionsRequired.unassign) this.signupMinIsSet = false;
      else this.signupMinIsSet = true;
    }
    if (config.noSignup && this.noSignupApplyFilter(optionsRequired.filter)) {
      this.noSignup = config.noSignup;
      if (optionsRequired.unassign) this.noSignupIsSet = false;
      else this.noSignupIsSet = true;
    }
    if (config.descLong && this.descLongApplyFilter(optionsRequired.filter)) {
      this.descLong = config.descLong;
      if (optionsRequired.unassign) this.descLongIsSet = false;
      else this.descLongIsSet = true;
    }
    if (config.descShort && this.descShortApplyFilter(optionsRequired.filter)) {
      this.descShort = config.descShort;
      if (optionsRequired.unassign) this.descShortIsSet = false;
      else this.descShortIsSet = true;
    }
    if (config.colorCode && this.colorCodeApplyFilter(optionsRequired.filter)) {
      this.colorCode = config.colorCode;
      if (optionsRequired.unassign) this.colorCodeIsSet = false;
      else this.colorCodeIsSet = true;
    }
    if (
      config.priceDefault &&
      this.priceDefaultApplyFilter(optionsRequired.filter)
    ) {
      this.priceDefault = config.priceDefault;
      if (optionsRequired.unassign) this.priceDefaultIsSet = false;
      else this.priceDefaultIsSet = true;
    }
    if (
      config.disallowIfOverkill &&
      this.disallowIfOverkillApplyFilter(optionsRequired.filter)
    ) {
      this.disallowIfOverkill = config.disallowIfOverkill;
      if (optionsRequired.unassign) this.disallowIfOverkillIsSet = false;
      else this.disallowIfOverkillIsSet = true;
    }
    if (config.teachUrl && this.teachUrlApplyFilter(optionsRequired.filter)) {
      this.teachUrl = config.teachUrl;
      if (optionsRequired.unassign) this.teachUrlIsSet = false;
      else this.teachUrlIsSet = true;
    }
    if (
      config.allowTeacher &&
      this.allowTeacherApplyFilter(optionsRequired.filter)
    ) {
      this.allowTeacher = config.allowTeacher;
      if (optionsRequired.unassign) this.allowTeacherIsSet = false;
      else this.allowTeacherIsSet = true;
    }
    if (
      config.teachRating &&
      this.teachRatingApplyFilter(optionsRequired.filter)
    ) {
      this.teachRating = new RatingRefTracked(config.teachRating, options);
      if (optionsRequired.unassign) this.teachRatingIsSet = false;
      else this.teachRatingIsSet = true;
    }
    if (
      config.ratingPrereq &&
      this.ratingPrereqApplyFilter(optionsRequired.filter)
    ) {
      this.ratingPrereq = new RatingRefTracked(config.ratingPrereq, options);
      if (optionsRequired.unassign) this.ratingPrereqIsSet = false;
      else this.ratingPrereqIsSet = true;
    }
    if (
      config.ratingOverkill &&
      this.ratingOverkillApplyFilter(optionsRequired.filter)
    ) {
      this.ratingOverkill = new RatingRefTracked(
        config.ratingOverkill,
        options,
      );
      if (optionsRequired.unassign) this.ratingOverkillIsSet = false;
      else this.ratingOverkillIsSet = true;
    }
    if (
      config.classPrereq &&
      this.classPrereqApplyFilter(optionsRequired.filter)
    ) {
      this.classPrereq = new ApClassTypeRefTracked(config.classPrereq, options);
      if (optionsRequired.unassign) this.classPrereqIsSet = false;
      else this.classPrereqIsSet = true;
    }
    if (
      config.classOverkill &&
      this.classOverkillApplyFilter(optionsRequired.filter)
    ) {
      this.classOverkill = new ApClassTypeRefTracked(
        config.classOverkill,
        options,
      );
      if (optionsRequired.unassign) this.classOverkillIsSet = false;
      else this.classOverkillIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ApClassTypeFullTrackedI {
    const cloned = {} as ApClassTypeFullTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.typeNameIsSetDeep() &&
      this.typeNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeNameIsSet = true;
      cloned.typeName = this.typeName;
    } else {
      //cloned.typeNameIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.prereqMustCompleteIsSetDeep() &&
      this.prereqMustCompleteApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.prereqMustCompleteIsSet = true;
      cloned.prereqMustComplete = this.prereqMustComplete;
    } else {
      //cloned.prereqMustCompleteIsSet = false
    }
    if (
      this.signupMaxIsSetDeep() &&
      this.signupMaxApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupMaxIsSet = true;
      cloned.signupMax = this.signupMax;
    } else {
      //cloned.signupMaxIsSet = false
    }
    if (
      this.signupMinIsSetDeep() &&
      this.signupMinApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupMinIsSet = true;
      cloned.signupMin = this.signupMin;
    } else {
      //cloned.signupMinIsSet = false
    }
    if (
      this.noSignupIsSetDeep() &&
      this.noSignupApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.noSignupIsSet = true;
      cloned.noSignup = this.noSignup;
    } else {
      //cloned.noSignupIsSet = false
    }
    if (
      this.descLongIsSetDeep() &&
      this.descLongApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.descLongIsSet = true;
      cloned.descLong = this.descLong;
    } else {
      //cloned.descLongIsSet = false
    }
    if (
      this.descShortIsSetDeep() &&
      this.descShortApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.descShortIsSet = true;
      cloned.descShort = this.descShort;
    } else {
      //cloned.descShortIsSet = false
    }
    if (
      this.colorCodeIsSetDeep() &&
      this.colorCodeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.colorCodeIsSet = true;
      cloned.colorCode = this.colorCode;
    } else {
      //cloned.colorCodeIsSet = false
    }
    if (
      this.priceDefaultIsSetDeep() &&
      this.priceDefaultApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceDefaultIsSet = true;
      cloned.priceDefault = this.priceDefault;
    } else {
      //cloned.priceDefaultIsSet = false
    }
    if (
      this.disallowIfOverkillIsSetDeep() &&
      this.disallowIfOverkillApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.disallowIfOverkillIsSet = true;
      cloned.disallowIfOverkill = this.disallowIfOverkill;
    } else {
      //cloned.disallowIfOverkillIsSet = false
    }
    if (
      this.teachUrlIsSetDeep() &&
      this.teachUrlApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.teachUrlIsSet = true;
      cloned.teachUrl = this.teachUrl;
    } else {
      //cloned.teachUrlIsSet = false
    }
    if (
      this.allowTeacherIsSetDeep() &&
      this.allowTeacherApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allowTeacherIsSet = true;
      cloned.allowTeacher = this.allowTeacher;
    } else {
      //cloned.allowTeacherIsSet = false
    }
    if (
      this.teachRatingIsSetDeep() &&
      this.teachRatingApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.teachRatingIsSet = true;
      cloned.teachRating = this.teachRating?.removeUnset(filter);
    } else {
      //cloned.teachRatingIsSet = false
    }
    if (
      this.ratingPrereqIsSetDeep() &&
      this.ratingPrereqApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ratingPrereqIsSet = true;
      cloned.ratingPrereq = this.ratingPrereq?.removeUnset(filter);
    } else {
      //cloned.ratingPrereqIsSet = false
    }
    if (
      this.ratingOverkillIsSetDeep() &&
      this.ratingOverkillApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ratingOverkillIsSet = true;
      cloned.ratingOverkill = this.ratingOverkill?.removeUnset(filter);
    } else {
      //cloned.ratingOverkillIsSet = false
    }
    if (
      this.classPrereqIsSetDeep() &&
      this.classPrereqApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classPrereqIsSet = true;
      cloned.classPrereq = this.classPrereq?.removeUnset(filter);
    } else {
      //cloned.classPrereqIsSet = false
    }
    if (
      this.classOverkillIsSetDeep() &&
      this.classOverkillApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classOverkillIsSet = true;
      cloned.classOverkill = this.classOverkill?.removeUnset(filter);
    } else {
      //cloned.classOverkillIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ApClassTypeFullTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.typeNameApplyFilter(filter)) this.typeNameIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.prereqMustCompleteApplyFilter(filter))
      this.prereqMustCompleteIsSet = false;

    if (!this.signupMaxApplyFilter(filter)) this.signupMaxIsSet = false;

    if (!this.signupMinApplyFilter(filter)) this.signupMinIsSet = false;

    if (!this.noSignupApplyFilter(filter)) this.noSignupIsSet = false;

    if (!this.descLongApplyFilter(filter)) this.descLongIsSet = false;

    if (!this.descShortApplyFilter(filter)) this.descShortIsSet = false;

    if (!this.colorCodeApplyFilter(filter)) this.colorCodeIsSet = false;

    if (!this.priceDefaultApplyFilter(filter)) this.priceDefaultIsSet = false;

    if (!this.disallowIfOverkillApplyFilter(filter))
      this.disallowIfOverkillIsSet = false;

    if (!this.teachUrlApplyFilter(filter)) this.teachUrlIsSet = false;

    if (!this.allowTeacherApplyFilter(filter)) this.allowTeacherIsSet = false;

    if (!this.teachRatingApplyFilter(filter)) this.teachRatingIsSet = false;
    this.teachRating?.unassignAll(filter);

    if (!this.ratingPrereqApplyFilter(filter)) this.ratingPrereqIsSet = false;
    this.ratingPrereq?.unassignAll(filter);

    if (!this.ratingOverkillApplyFilter(filter))
      this.ratingOverkillIsSet = false;
    this.ratingOverkill?.unassignAll(filter);

    if (!this.classPrereqApplyFilter(filter)) this.classPrereqIsSet = false;
    this.classPrereq?.unassignAll(filter);

    if (!this.classOverkillApplyFilter(filter)) this.classOverkillIsSet = false;
    this.classOverkill?.unassignAll(filter);

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.assignId,
      ApClassTypeFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  typeNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.typeName,
      ApClassTypeFullMeta,
      this.typeName,
      this,
    );
  }
  typeNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeNameIsSet && this.typeNameApplyFilter(filter)) return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.displayOrder,
      ApClassTypeFullMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  prereqMustCompleteApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.prereqMustComplete,
      ApClassTypeFullMeta,
      this.prereqMustComplete,
      this,
    );
  }
  prereqMustCompleteIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.prereqMustCompleteIsSet &&
      this.prereqMustCompleteApplyFilter(filter)
    )
      return true;

    return false;
  }
  signupMaxApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.signupMax,
      ApClassTypeFullMeta,
      this.signupMax,
      this,
    );
  }
  signupMaxIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupMaxIsSet && this.signupMaxApplyFilter(filter)) return true;

    return false;
  }
  signupMinApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.signupMin,
      ApClassTypeFullMeta,
      this.signupMin,
      this,
    );
  }
  signupMinIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupMinIsSet && this.signupMinApplyFilter(filter)) return true;

    return false;
  }
  noSignupApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.noSignup,
      ApClassTypeFullMeta,
      this.noSignup,
      this,
    );
  }
  noSignupIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.noSignupIsSet && this.noSignupApplyFilter(filter)) return true;

    return false;
  }
  descLongApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.descLong,
      ApClassTypeFullMeta,
      this.descLong,
      this,
    );
  }
  descLongIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.descLongIsSet && this.descLongApplyFilter(filter)) return true;

    return false;
  }
  descShortApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.descShort,
      ApClassTypeFullMeta,
      this.descShort,
      this,
    );
  }
  descShortIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.descShortIsSet && this.descShortApplyFilter(filter)) return true;

    return false;
  }
  colorCodeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.colorCode,
      ApClassTypeFullMeta,
      this.colorCode,
      this,
    );
  }
  colorCodeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.colorCodeIsSet && this.colorCodeApplyFilter(filter)) return true;

    return false;
  }
  priceDefaultApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.priceDefault,
      ApClassTypeFullMeta,
      this.priceDefault,
      this,
    );
  }
  priceDefaultIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceDefaultIsSet && this.priceDefaultApplyFilter(filter))
      return true;

    return false;
  }
  disallowIfOverkillApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.disallowIfOverkill,
      ApClassTypeFullMeta,
      this.disallowIfOverkill,
      this,
    );
  }
  disallowIfOverkillIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.disallowIfOverkillIsSet &&
      this.disallowIfOverkillApplyFilter(filter)
    )
      return true;

    return false;
  }
  teachUrlApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.teachUrl,
      ApClassTypeFullMeta,
      this.teachUrl,
      this,
    );
  }
  teachUrlIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.teachUrlIsSet && this.teachUrlApplyFilter(filter)) return true;

    return false;
  }
  allowTeacherApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.allowTeacher,
      ApClassTypeFullMeta,
      this.allowTeacher,
      this,
    );
  }
  allowTeacherIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.allowTeacherIsSet && this.allowTeacherApplyFilter(filter))
      return true;

    return false;
  }
  teachRatingApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.teachRating,
      ApClassTypeFullMeta,
      this.teachRating,
      this,
    );
  }
  teachRatingIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.teachRatingIsSet && this.teachRatingApplyFilter(filter))
      return true;
    return this.teachRating?.anySet(filter) == true;

    return false;
  }
  ratingPrereqApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.ratingPrereq,
      ApClassTypeFullMeta,
      this.ratingPrereq,
      this,
    );
  }
  ratingPrereqIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ratingPrereqIsSet && this.ratingPrereqApplyFilter(filter))
      return true;
    return this.ratingPrereq?.anySet(filter) == true;

    return false;
  }
  ratingOverkillApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.ratingOverkill,
      ApClassTypeFullMeta,
      this.ratingOverkill,
      this,
    );
  }
  ratingOverkillIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ratingOverkillIsSet && this.ratingOverkillApplyFilter(filter))
      return true;
    return this.ratingOverkill?.anySet(filter) == true;

    return false;
  }
  classPrereqApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.classPrereq,
      ApClassTypeFullMeta,
      this.classPrereq,
      this,
    );
  }
  classPrereqIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classPrereqIsSet && this.classPrereqApplyFilter(filter))
      return true;
    return this.classPrereq?.anySet(filter) == true;

    return false;
  }
  classOverkillApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.classOverkill,
      ApClassTypeFullMeta,
      this.classOverkill,
      this,
    );
  }
  classOverkillIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classOverkillIsSet && this.classOverkillApplyFilter(filter))
      return true;
    return this.classOverkill?.anySet(filter) == true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.isDeleted,
      ApClassTypeFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.isNew,
      ApClassTypeFullMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.updatedOn,
      ApClassTypeFullMeta,
      this.updatedOn,
      this,
    );
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.updatedBy,
      ApClassTypeFullMeta,
      this.updatedBy,
      this,
    );
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.createdOn,
      ApClassTypeFullMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeFullMeta.createdBy,
      ApClassTypeFullMeta,
      this.createdBy,
      this,
    );
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.typeNameIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.prereqMustCompleteIsSetDeep(filter)) return true;
    if (this.signupMaxIsSetDeep(filter)) return true;
    if (this.signupMinIsSetDeep(filter)) return true;
    if (this.noSignupIsSetDeep(filter)) return true;
    if (this.descLongIsSetDeep(filter)) return true;
    if (this.descShortIsSetDeep(filter)) return true;
    if (this.colorCodeIsSetDeep(filter)) return true;
    if (this.priceDefaultIsSetDeep(filter)) return true;
    if (this.disallowIfOverkillIsSetDeep(filter)) return true;
    if (this.teachUrlIsSetDeep(filter)) return true;
    if (this.allowTeacherIsSetDeep(filter)) return true;
    if (this.teachRatingIsSetDeep(filter)) return true;
    if (this.ratingPrereqIsSetDeep(filter)) return true;
    if (this.ratingOverkillIsSetDeep(filter)) return true;
    if (this.classPrereqIsSetDeep(filter)) return true;
    if (this.classOverkillIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
